import React from "react";
import { BaseEdge, EdgeLabelRenderer } from "@xyflow/react";
import { Box } from "@mui/material";
import { ColorsConstants } from "../../../cssUtils/constants";
import { getOffsetEdgePath } from "./offsetEdgePath";

// Smoothstep edge that can be shifted sideways. Edges that share the same source and target
// would be drawn on top of each other with their labels on the same spot, so each one gets its
// own line, offset from the handles, with the label sitting on it.
const OffsetLabelEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  label,
  data,
}) => {
  const [path, labelX, labelY] = getOffsetEdgePath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    offsetX: data?.offsetX,
  });

  return (
    <>
      <BaseEdge path={path} markerEnd={markerEnd} style={style} />
      {label && (
        <EdgeLabelRenderer>
          <Box
            className="nodrag nopan"
            sx={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              px: 0.75,
              py: 0.25,
              fontSize: 11,
              borderRadius: 1,
              whiteSpace: "nowrap",
              pointerEvents: "all",
              backgroundColor: "white",
              border: "1px solid",
              borderColor: ColorsConstants.primaryGray10,
            }}
          >
            {label}
          </Box>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default OffsetLabelEdge;
